import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BrandService {
  private apiUrl = environment.apiURL+'brands'; // URL del API
  private cache$: Observable<any> | null = null;

  constructor(private http: HttpClient) {}

  getData(): Observable<any> {
    if (!this.cache$) {
      this.cache$ = this.http.get(this.apiUrl).pipe(
        shareReplay({ bufferSize: 1, refCount: false })
      );
    }
    return this.cache$;
  }

  addData(item: any): Observable<any> {
    this.cache$ = null; // Invalidar cache al agregar
    return this.http.post(this.apiUrl+"/new", item);
  }

}
